import dashboardSettingsSlice from './dashboardSettingsSlice'

export default dashboardSettingsSlice;